<div
	class="qo-position-relative"
	[ngStyle]="{'max-height': maxHeight + 'px', 'width': '250px'}"
>
	<div
		class="selected-option"
		(click)="show ? show = false : show = true"
		(clickOutside)="show = false"
	>
		<div class="qo-mat-nested-input-field show-borders qo-max-width">
			<div class="text">{{selectedOption?.text}}</div>
			<qo-icon [icon]="EQORebrandIcon.arrow_down_dark" [size]="'sm'"></qo-icon>
		</div>
	</div>
	<div
		class="qo-position-absolute qo-flex-col-top-left selector"
		[ngStyle]="{'max-height': maxHeight + 'px'}"
		*ngIf="show"
	>
		<div class="title qo-padding10">{{title}}</div>
		<div class="qo-flex-col-top-left">
			<div
				class="option qo-max-width"
				*ngFor="let option of options"
				(click)="selectionChanged.emit(option)"
			>
				<div class="qo-flex-row-top-left opt">
					<qo-profile-image
						[imageUrl]="option.image"
						[letter]="option.initials"
						[size]="25"
					></qo-profile-image>
					<div class="qo-margin-left10">{{option.text}}</div>
				</div>
			</div>
		</div>
	</div>
</div>
